import {TopBannerTitleDefaultBox} from "./top-banner-title.default.box";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {TopBannerTitleCasino777Box} from "./top-banner-title.casino777.box";

export const TopBannerTitleBox = styledByTheme(TopBannerTitleDefaultBox).forCasino777(TopBannerTitleCasino777Box).apply();